import React from "react";
import { useFormContext } from "react-hook-form";
import MUploadFile from "@app/components/MUploadFile";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";

export function cleanFileName(filePath) {
  if (!filePath) return "";
  const fileName = filePath.split("/").pop();
  const lastUnderscoreIndex = fileName.lastIndexOf("_");
  if (lastUnderscoreIndex === -1) return fileName;
  const cleanName = fileName.substring(0, lastUnderscoreIndex) + ".RPT";
  return cleanName;
}

export const parseRptFileExe = (content) => {
  return content.split("|") || content;
};

interface FileUploadAreaExeProps {
  name: string;
  isRequired?: boolean;
}

const FileUploadAreaExeGT = ({
  name,
  isRequired = true,
}: FileUploadAreaExeProps) => {
  const { setValue, getValues, watch } = useFormContext();

  const { currentCalculation, importFileFromRoute } = useAnalysis();

  const parseRptFile = (content) => {
      if (name === "source_app_calculation_info_file") {
      const lines: string[] = parseRptFileExe(content);
      setValue("total_sample_counting_time", lines[1]);
      setValue("calculation_date_countig_file_exe", lines[2]);
      setValue("pico_counts_341", lines[4]);
      setValue("pico_counts_911", lines[5]);
      setValue("detector_file", lines[3]);
    }
  };

  const handleDownload = async () => {
    await importFileFromRoute(getValues(name), "DOWNLOAD");
  };
  const isDisabled = Boolean(watch("idResultPreload"));

  return (
    <MUploadFile
      key={`${getValues(name)}_exe`}
      acceptFile=".txt"
      onFileChange={parseRptFile}
      name={`${name}_exe`}
      preloadNameFile={cleanFileName(getValues(name))}
      validation={
        currentCalculation.id || !isRequired
          ? {}
          : { required: "Este campo es requerido" }
      }
      downloadFile={currentCalculation.id ? handleDownload : undefined}
      disabled={isDisabled}
    />
  );
};
export default FileUploadAreaExeGT;
